import React, { Component } from 'react'
import moment from 'moment'
import { Form, Select, Tabs } from 'antd'
import _ from 'lodash'
import $ from 'jquery'

import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import Errors from 'validatorjs/src/errors'
import { __ } from '@wordpress/i18n'

const VC_CONFIG = _.get(window, 'VC_CONFIG', {})
const Local = _.get(window, 'VC_CONFIG.Locale')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
// 前端頁面
export default class UserPayment extends Component {
  formRef = React.createRef()
  state = {
    query: {},
    listInfo: _.cloneDeep(defaultListInfo),
    tableData: [],
    tableData_Detail: [],
    selectmonth: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    isLoading: true,
  }

  componentDidMount() {
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    const query = {
      start_dt: moment(firstDay).format('YYYY-MM-DD'),
      end_dt: moment(lastDay).format('YYYY-MM-DD'),
    }
    // AppHelper.updateConfig()
    this.setState({ query })
    this.setState({ info: this.props.user }, () => {
      this.reloadTab()
    })
    this.loadData(query)
    this.control()
  }
  control = () => {
    $(document).ready(function() {
      $(document).on(
        'show.bs.collapse',
        '.tbody .order-detail-info',
        function() {
          $('.order-detail-info').removeClass('show')
          //$(this).addClass('show');
        }
      )
    })
  }
  clickgetdetail = (ID = '') => {
    console.log('555555555555555555', ID)
    this.setState({ isLoading: true })
    whttp.post(
      API_HOST + '/api/account/purchaseDetail',
      {
        pur_id: ID,
      },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false) {
          return this.setState({ message: '發生錯誤' })
        }

        if (code !== 200) {
          return this.setState({ message: reason })
        }
        this.setState(
          { tableData_Detail: data.purchaseDetail, isLoading: false },
          () => {
            this.refreshPicker()
          }
        )
      }
    )
  }
  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }
  loadData = (query = {}) => {
    console.log('loadData', query)
    //const { query } = this.state;
    const { page, page_size } = { page: 1, page_size: 'all' }

    this.setState({ isLoadingData: true })

    whttp.post(
      API_HOST + '/api/account/purchaseList',
      {
        start_dt: query.start_dt,
        end_dt: query.end_dt,
      },
      (state, res) => {
        this.setState({ isLoadingData: false })
        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false) {
          return this.setState({ message: '發生錯誤' })
        }

        if (code !== 200) {
          return this.setState({ message: reason })
        }
        console.log(code, reason, data, res)
        this.setState({ tableData: data.purchases }, () => {
          this.refreshPicker()
        })
      }
    )
  }
  fillData = (data = {}) => {
    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.address) || !_.isObject(data.address)) {
      data.address = {
        city_id: _.get(data, 'city_id'),
        area_id: _.get(data, 'area_id'),
      }
    }

    console.log('filldata', data)
    this.formRef.current.setFieldsValue(data)
    this.setState({ isLoading: false }, () => {
      this.reloadTab()
    })
  }

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh')
  }, 1000)
  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const options = _.get(this, 'props.app.options', {})
    const { query, info, tableData = [], tableData_Detail = [] } = this.state
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    var tmpStr_area = '',
      tmpResult_area =
        '<option value="' +
        moment(firstDay).format('YYYY-MM-DD') +
        '">' +
        moment(firstDay).format('YYYY年MM月') +
        '</option>'
    for (var i = 0; i < 5; i++) {
      tmpStr_area =
        '<option value="' +
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY-MM-DD') +
        '">' +
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY年MM月') +
        '</option>'
      tmpResult_area = tmpResult_area + tmpStr_area
      firstDay = moment(firstDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
      lastDay = moment(lastDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
    }
    $('#SelectMonth').html(tmpResult_area)
    this.refreshPicker()
    const tttttt = [
      {
        items: [
          {
            sku_amount: 20,
            sku_id: 381179,
            sku_name: '安心茶葉蛋',
            sku_price: null,
            sku_quantity: 2,
          },
        ],
        payments: [
          {
            amount: 20,
            payment_id: '24',
          },
        ],
        pur_amount: 20,
        pur_dt: '2020-05-13 17:56:00',
        pur_id: 1302780146,
        pur_pos_amt: 1035,
        pur_pos_pts: 310718,
        pur_redeem_pts: 0,
        pur_reward_pts: 40,
        pur_store: '北投店',
        pur_type: '00',
      },
      {
        items: [
          {
            sku_amount: 55,
            sku_id: 7335249,
            sku_name: '1/4核桃吐司',
            sku_price: null,
            sku_quantity: 1,
          },
          {
            sku_amount: 25,
            sku_id: 500921,
            sku_name: '每朝健康綠無糖',
            sku_price: null,
            sku_quantity: 1,
          },
          {
            sku_amount: 28,
            sku_id: 6996733,
            sku_name: '1/4芝麻吐司',
            sku_price: null,
            sku_quantity: 1,
          },
        ],
        payments: [
          {
            amount: 108,
            payment_id: '24',
          },
        ],
        pur_amount: 108,
        pur_dt: '2020-05-12 16:19:00',
        pur_id: 1302465840,
        pur_pos_amt: 1035,
        pur_pos_pts: 310502,
        pur_redeem_pts: 0,
        pur_reward_pts: 216,
        pur_store: '北投店',
        pur_type: '00',
      },
      {
        items: [
          {
            sku_amount: 20,
            sku_id: 381179,
            sku_name: '安心茶葉蛋',
            sku_price: null,
            sku_quantity: 2,
          },
        ],
        payments: [
          {
            amount: 20,
            payment_id: '24',
          },
        ],
        pur_amount: 20,
        pur_dt: '2020-05-13 17:56:00',
        pur_id: 1302780155,
        pur_pos_amt: 1035,
        pur_pos_pts: 310718,
        pur_redeem_pts: 0,
        pur_reward_pts: 40,
        pur_store: '北投店',
        pur_type: '00',
      },
    ]
    return (
      <div>
        <main className='bg-light'>
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  {Local == 'zh_TW' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      {/* <li
                        className='breadcrumb-item active'
                        aria-current='page'
                      >
                        {__('我的消費紀錄', 'cec-plugin-stores')}
                      </li> */}
                    </ol>
                  )}
                  {Local == 'en_US' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/en`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      {/* <li
                        className='breadcrumb-item active'
                        aria-current='page'
                      >
                        {__('我的消費紀錄', 'cec-plugin-stores')}
                      </li> */}
                    </ol>
                  )}
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}{' '}
                <b className='fw-700'>{info && info.cn_name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
            </section>
          </div>
          <section className='pt-0'>
            <div className='mb-5 basic-tabs-label'>
              {Local == 'zh_TW' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${VC_CONFIG.INDEX_URL}/pwd`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/point`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/invoice`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/connect`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
              {Local == 'en_US' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                      {__('網站帳號', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {info && info.spcode === 'C4' && (
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${VC_CONFIG.INDEX_URL}/pwd-en`}>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile-en`}>
                      {__('好康卡會員資料', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item current_page_item highlight'>
                    <a className='nav-link'>
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/point-en`}>
                      {__('點數紀錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/invoice-en`}>
                      {__('電子發票記錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/connect-en`}>
                      {__('第三方登入設定', 'cec-plugin-stores')}
                    </a>
                  </li>
                </ul>
              )}
            </div>
            <div className='container'>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <div className='row justify-content-center'>
                        <div className='col-6 col-lg-9'>
                          <h5 className='h4 text-navy text-center mb-0'>
                            {__('查詢月份', 'cec-plugin-stores')}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <div className='row'>
                        <div className='col-sm-4'>
                          <select
                            className='form-select selectpicker'
                            name='SelectMonth'
                            id='SelectMonth'
                            value={this.state.selectmonth}
                            onChange={(e) => {
                              query.start_dt = e.target.value
                              query.end_dt = moment(e.target.value)
                                .endOf('month')
                                .format('YYYY-MM-DD')
                              this.loadData(query)
                              this.setState({ selectmonth: e.target.value })
                            }}
                          />
                        </div>
                        <div className='col-sm-8'>
                          <p className='h6 text-navy fw-700 mb-2'>
                            {__(
                              '網站僅提供六個月內消費記錄查詢, 若您對您的消費記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！',
                              'cec-plugin-stores',
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-12 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5 p-lg-0'>
                      <div className='flex-table' data-theme='success'>
                        <div className='thead'>
                          <ul className='table-row'>
                            <li>{__('消費日期', 'cec-plugin-stores')}</li>
                            <li>{__('分店名稱', 'cec-plugin-stores')}</li>
                            <li>{__('交易型態', 'cec-plugin-stores')}</li>
                            <li>{__('消費金額', 'cec-plugin-stores')}</li>
                            <li>{__('紅利折抵', 'cec-plugin-stores')}</li>
                            <li>{__('獲得點數', 'cec-plugin-stores')}</li>
                          </ul>
                        </div>
                        {tableData.length == 0 && (
                          <div className='tbody'>
                            <ul className='table-row'>
                              <li data-title='消費日期'>
                                {__(
                                  '尚無任何消費記錄',
                                  'cec-plugin-stores',
                                )}
                              </li>
                            </ul>
                          </div>
                        )}
                        {tableData.map((v, idx) => {
                          return (
                            <div className='tbody'>
                              <ul
                                class='table-row order-detail-item'
                                data-toggle='collapse'
                                href={`#order-detail-${v.pur_id}`}
                                role='button'
                                aria-expanded='false'
                                aria-controls={`#order-detail-${v.pur_id}`}
                                id={v.pur_id}
                                onClick={() =>
                                  this.clickgetdetail(String(v.pur_id))
                                }>
                                <li data-title='消費日期'>{v.pur_dt}</li>
                                <li data-title='分店名稱'>
                                  {v.pur_store && v.pur_store}
                                  {!v.pur_store &&
                                    __('店外消費', 'cec-plugin-stores')}
                                </li>
                                <li data-title='交易型態'>
                                  {__('消費', 'cec-plugin-stores')}
                                </li>
                                <li data-title='消費金額'>
                                  {Local == 'en_US' &&
                                    v.pur_amount &&
                                    `$${v.pur_amount}`}
                                  {Local == 'zh_TW' &&
                                    v.pur_amount &&
                                    `${v.pur_amount}元`}
                                </li>
                                <li data-title='折抵'>
                                  {v.pur_redeem_pts && v.pur_redeem_pts}
                                  {__('點', 'cec-plugin-stores')}
                                </li>
                                <li data-title='累積點數'>
                                  {v.pur_reward_pts && v.pur_reward_pts}
                                  {__('點', 'cec-plugin-stores')}
                                </li>
                              </ul>
                              <div
                                class='order-detail-info collapse'
                                id={`order-detail-${v.pur_id}`}>
                                <div class='card'>
                                  <div class='card-body'>
                                    <div class='card points-list'>
                                      <h5 class='card-header'>
                                        {__(
                                          '點數明細',
                                          'cec-plugin-stores',
                                        )}
                                      </h5>
                                      <div class='card-body py-0'>
                                        <ul class='list-unstyled'>
                                          <li class='d-flex align-items-center justify-content-between text-navy my-4'>
                                            <p class='p text-left mb-0'>
                                              {__(
                                                '本次交易扣除點數',
                                                'cec-plugin-stores',
                                              )}
                                            </p>
                                            <p class='p text-right mb-0'>
                                              {tableData_Detail.pur_redeem_pts &&
                                                tableData_Detail.pur_redeem_pts}{' '}
                                              點
                                            </p>
                                          </li>
                                          <li class='d-flex align-items-center justify-content-between text-navy my-4'>
                                            <p class='p text-left mb-0'>
                                              {__(
                                                '紅利點數可用餘額',
                                                'cec-plugin-stores',
                                              )}
                                            </p>
                                            <p class='p text-right mb-0'>
                                              {tableData_Detail.pur_pos_pts &&
                                                tableData_Detail.pur_pos_pts}{' '}
                                              點
                                            </p>
                                          </li>
                                          <li class='d-flex align-items-center justify-content-between text-navy my-4'>
                                            <p class='p text-left mb-0'>
                                              {__(
                                                '換算可折抵金額',
                                                'cec-plugin-stores',
                                              )}
                                            </p>
                                            <p class='p text-right mb-0'>
                                              {tableData_Detail.pur_pos_amt &&
                                                tableData_Detail.pur_pos_amt}{' '}
                                              點
                                            </p>
                                          </li>
                                          <li class='d-flex align-items-center justify-content-between text-navy my-4'>
                                            <p class='p text-left mb-0'>
                                              {__(
                                                '本次回饋點數總計',
                                                'cec-plugin-stores',
                                              )}
                                            </p>
                                            <p class='p text-right mb-0'>
                                              {tableData_Detail.pur_reward_pts &&
                                                tableData_Detail.pur_reward_pts}{' '}
                                              點
                                            </p>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class='card order-list'>
                                      <h5 class='card-header'>
                                        {__(
                                          '交易明細',
                                          'cec-plugin-stores',
                                        )}
                                      </h5>
                                      <div class='card-body p-0'>
                                        <div
                                          class='flex-table'
                                          data-theme='light'>
                                          <div class='thead'>
                                            <ul class='table-row'>
                                              <li>
                                                {__(
                                                  '品名',
                                                  'cec-plugin-stores',
                                                )}
                                              </li>
                                              <li>
                                                {__(
                                                  '數量',
                                                  'cec-plugin-stores',
                                                )}
                                              </li>
                                              <li>
                                                {__(
                                                  '金額',
                                                  'cec-plugin-stores',
                                                )}
                                              </li>
                                            </ul>
                                          </div>
                                          <div class='thead tbody'>
                                            {_.map(
                                              tableData_Detail.items,
                                              (item, idx) => (
                                                <ul class='table-row'>
                                                  <li
                                                    class='text-lg-left'
                                                    data-title='品名'>
                                                    {item.sku_name &&
                                                      item.sku_name}
                                                  </li>
                                                  <li data-title='數量'>
                                                    {item.sku_quantity &&
                                                      item.sku_quantity}
                                                  </li>
                                                  <li
                                                    class='text-lg-right'
                                                    data-title='金額'>
                                                    $
                                                    {item.sku_amount &&
                                                      item.sku_amount}
                                                  </li>
                                                </ul>
                                              ),
                                            )}
                                            {_.map(
                                              tableData_Detail.payments,
                                              (pay, idx) => (
                                                <ul class='table-row'>
                                                  <li class='text-lg-left d-none d-lg-block'>
                                                    {' '}
                                                  </li>
                                                  <li>
                                                    {__(
                                                      '小計',
                                                      'cec-plugin-stores',
                                                    )}
                                                  </li>
                                                  <li
                                                    class='text-lg-right'
                                                    data-title='金額'>
                                                    $
                                                    {pay.amount &&
                                                      pay.amount}
                                                  </li>
                                                </ul>
                                              ),
                                            )}
                                            <ul class='table-row'>
                                              <li class='text-lg-left'>
                                                &nbsp;
                                              </li>
                                              <li>
                                                {__(
                                                  '實付',
                                                  'cec-plugin-stores',
                                                )}
                                              </li>
                                              <li class='text-lg-right'>
                                                $
                                                {tableData_Detail.pur_amount &&
                                                  tableData_Detail.pur_amount}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                      {/* <div className="text-center mt-5 my-lg-5"><a className="h6 btn btn-success rounded-pill px-5 py-2 mb-0" role="button" href="#">看更多</a></div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 className='h4 text-navy text-center'>
                        {__('注意事項', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '客服中心：市話 0809-001-365 / 手機(02)8006-9999 ',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserPaymentEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-catalogue-list-editor'>
        <h2>會員消費記錄模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-payment.js